/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  FineTuningJob,
  FineTuningJob$inboundSchema,
  FineTuningJob$Outbound,
  FineTuningJob$outboundSchema,
} from "./finetuningjob.js";

export type ListFineTuningJobsResponse = {
  object: "list";
  data: Array<FineTuningJob>;
  hasMore: boolean;
};

/** @internal */
export const ListFineTuningJobsResponse$inboundSchema: z.ZodType<
  ListFineTuningJobsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  data: z.array(FineTuningJob$inboundSchema),
  has_more: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    "has_more": "hasMore",
  });
});
/** @internal */
export type ListFineTuningJobsResponse$Outbound = {
  object: "list";
  data: Array<FineTuningJob$Outbound>;
  has_more: boolean;
};

/** @internal */
export const ListFineTuningJobsResponse$outboundSchema: z.ZodType<
  ListFineTuningJobsResponse$Outbound,
  z.ZodTypeDef,
  ListFineTuningJobsResponse
> = z.object({
  object: z.literal("list"),
  data: z.array(FineTuningJob$outboundSchema),
  hasMore: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    hasMore: "has_more",
  });
});

export function listFineTuningJobsResponseToJSON(
  listFineTuningJobsResponse: ListFineTuningJobsResponse,
): string {
  return JSON.stringify(
    ListFineTuningJobsResponse$outboundSchema.parse(listFineTuningJobsResponse),
  );
}
export function listFineTuningJobsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListFineTuningJobsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListFineTuningJobsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListFineTuningJobsResponse' from JSON`,
  );
}
